import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductDetails() {
  return <section className="w-full bg-[#1a1f2e] py-16 md:py-24 px-4" data-id="element-166">
      <div className="max-w-4xl mx-auto" data-id="element-167">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8edf4] mb-12 text-center" data-id="element-168">
          ¿Qué recibes?
        </h2>

        <div className="bg-[#1e2738] rounded-2xl p-8 md:p-12 shadow-lg shadow-black/20 ring-1 ring-white/5" data-id="element-169">
          <p className="text-xl text-[#e8edf4] mb-8" data-id="element-170">
            Un PDF (manual nocturno) que incluye:
          </p>

          <ul className="space-y-6" data-id="element-171">
            <li className="flex items-start gap-4" data-id="element-172">
              <CheckCircleIcon className="w-6 h-6 text-[#a8b5d1] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-173" />
              <span className="text-lg text-[#d1d9e6]" data-id="element-174">
                Ritual completo de 10 minutos
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-175">
              <CheckCircleIcon className="w-6 h-6 text-[#a8b5d1] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-176" />
              <span className="text-lg text-[#d1d9e6]" data-id="element-177">
                Variaciones según ansiedad alta/media/baja
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-178">
              <CheckCircleIcon className="w-6 h-6 text-[#a8b5d1] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-179" />
              <span className="text-lg text-[#d1d9e6]" data-id="element-180">
                Plantillas imprimibles: brain dump, checklist, tarjeta 3AM
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-181">
              <CheckCircleIcon className="w-6 h-6 text-[#a8b5d1] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-182" />
              <span className="text-lg text-[#d1d9e6]" data-id="element-183">
                Antídotos para los 7 pensamientos típicos nocturnos
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-184">
              <CheckCircleIcon className="w-6 h-6 text-[#a8b5d1] flex-shrink-0 mt-1" aria-hidden="true" data-id="element-185" />
              <span className="text-lg text-[#d1d9e6]" data-id="element-186">
                Plan de 7 noches (seguimiento mínimo)
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}